import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import { 
  MainBodyContent,
  StatusTag,
  StdActionCommentModal
} from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { 
  bgCompanyRequestPath,
  bgCompanyRequestDetailPath
} from 'routes'
import { 
  BottomActionsContainer,
} from './styled'
import { 
  getBGCompanyRequestDetail,
  getBGCRFlowDetail,
  updateBGCompanyRequest,
  deleteBGCompanyRequest,
  resubmitBGCompanyRequest,
  actionBGCompanyRequest
} from 'ducks/bgCompanyRequest'
import { 
  getListDocForExtend,
} from 'ducks/bgCompany'
import { validateField } from '../helper'
import { getVendors, getCompanies, getCustomers } from 'ducks/options'
import { statusColor, buttonColor } from '../AttributeData'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import RequestForComponent from '../Shareds/RequestFor'
import BankGuaranteeInformation from '../Shareds/BankGuaranteeInformation'
import GeneralInformation from '../Shareds/GeneralInformation'
import ContactComponent from '../Shareds/Contact'
import AttachmentComponent from '../Shareds/Attachment'
import CommentComponent from '../Shareds/Comment'

const EditBankGuaranteeCompanyRequest = (props) => {

  const { 
    detailDocForExtend,
    valueForm, 
    username,
    change,
    history,
    isDetail = false
  } = props

  const actionName = React.useRef('')
  const [showConfirm, setShowConfirm] = React.useState(false)
  const [showConfirmComment, setShowConfirmComment] = React.useState(false)

  React.useEffect(()=>{ // check to detil mode
    if(valueForm.id){
      if([0,500].indexOf(valueForm.status)<0){
        history.replace(bgCompanyRequestDetailPath(valueForm.id))
      }else if(username != valueForm.createdBy){
        history.replace(bgCompanyRequestDetailPath(valueForm.id))
      }
    }
  },[valueForm.id])

  React.useEffect(() => {
    props.getBGCompanyRequestDetail(props.match.params.id, history)
    props.getBGCRFlowDetail(props.match.params.id)
    props.getVendors()
    props.getCompanies()
    props.getCustomers()
    props.getListDocForExtend()
  }, [])

  React.useEffect(()=>{
    if(valueForm.requestType=='extend'&&detailDocForExtend.id){
      change('companyCode',detailDocForExtend.companyCode)
      change('requestForType',detailDocForExtend.requestForType)
      change('requestForCode',detailDocForExtend.requestForCode)
      change('typeOfBond',detailDocForExtend.typeOfBond)
      if(detailDocForExtend.typeOfBondOther){
        change('typeOfBondOther',detailDocForExtend.typeOfBondOther)
      }
      change('amount',detailDocForExtend.amount)
      if(valueForm.isReferenceOriginal){
        change('referenceDocumentType',detailDocForExtend.referenceDocumentType)
        if(detailDocForExtend.referenceContractDate){
          change('referenceContractDate',detailDocForExtend.referenceContractDate)
        }
        if(detailDocForExtend.referenceContractNumber){
          change('referenceContractNumber',detailDocForExtend.referenceContractNumber)
        }
        if(detailDocForExtend.referencePurchaseOrderNumber){
          change('referencePurchaseOrderNumber',detailDocForExtend.referencePurchaseOrderNumber)
        }
        change('requesterUser',detailDocForExtend.requesterUser)
        change('projectManagerUser',detailDocForExtend.projectManagerUser)
        change('isContactValid',true)
        //contact
        let previousContacts = valueForm.contacts.map(x=>{
          x.deleted = true
          return x
        })
        detailDocForExtend.contacts.forEach(x=>{
          previousContacts.push(x)
        })
        change('contacts',previousContacts)
        //attachment
        let previousAttachments = valueForm.attachments.map(x=>{
          if(x.documentCode=='BGC01'||x.documentCode=='BGC02'){
            x.deleted = true
            return x
          }else{
            return x
          }
        })
        if(detailDocForExtend.referenceDocumentType=='contract'){
          let newAttachments = detailDocForExtend.attachments.filter(x=>x.documentCode=='BGC01')
          newAttachments.forEach(x=>{
            previousAttachments.push(x)
          })
          change('attachments',previousAttachments)
        }
        if(detailDocForExtend.referenceDocumentType=='poNumber'){
          let newAttachments = detailDocForExtend.attachments.filter(x=>x.documentCode=='BGC02')
          newAttachments.forEach(x=>{
            previousAttachments.push(x)
          })
          change('attachments',previousAttachments)
        }
      }
    }
  },[detailDocForExtend])

  const onRequestTypeChange = (type) => {
    if(type=='new'){
      change('typeOfBond','')
      change('amount','')
      change('referenceDocumentType','')
      change('referenceContractDate','')
      change('referenceContractNumber','')
      change('extendBankGuaranteeId',null)
      change('referencePurchaseOrderNumber','')
      change('requesterUser','')
      change('projectManagerUser','')
      change('isContactValid',false)
      let previousContacts = valueForm.contacts.map(x=>{
        x.deleted = true
        return x
      })
      change('contacts',previousContacts)
      let previousAttachments = valueForm.attachments.map(x=>{
        if(x.documentCode!='BGC04') x.deleted = true
        return x
      })
      change('attachments',previousAttachments)
    }
  }

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      setShowConfirm(true)
    })
  } 

  const onCancelForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      //validate DATA
      var errors = {}
      if(!valueForm.comment) errors.comment = 'Required!'
      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      } else {
        setShowConfirmComment(false)
        props.actionBGCompanyRequest(
          {
            docId:valueForm.id,
            sn:valueForm.sn,
            action:'Cancel',
            comment:valueForm.comment,
          },
          props.history
        )
      }
    })
  } 


  const confirmSubmit = () =>{
    setShowConfirm(false)
    if(actionName.current == 'Delete'){
      props.deleteBGCompanyRequest(valueForm.id, history)
    }else if(actionName.current == 'Resubmit'){
      props.resubmitBGCompanyRequest(valueForm, history)
    }else{
      props.updateBGCompanyRequest(valueForm,actionName.current=='Submit',history)
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Request Bank Guarantee - ${valueForm.documentNumber||'Edit'}`}
          <StatusTag status={valueForm.status} statusName={valueForm.statusName} style={{background:statusColor[`${valueForm.status}`],marginLeft: '10px'}}/>
        </React.Fragment>
      }
      
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'BG Company - Request New/Extend', link: true, onClick: () => history.push(bgCompanyRequestPath) },
              { key: 'BGEdit', content: 'Edit', active: true }
            ]
          }
        />
      }
    >
      <DocumentStep documentDetail={valueForm} approvers={props.flowDetail} />
      <RequestForComponent isEdit onRequestTypeChange={onRequestTypeChange}/>
      {valueForm.requestType?
        <React.Fragment>
          <BankGuaranteeInformation isEdit/>
          <GeneralInformation isEdit isDetail={isDetail}/>
          <ContactComponent isEdit/>
          <AttachmentComponent isEdit/>
          <CommentComponent/>
          <div style={{height:'1rem'}}/>
          <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
            <BottomActionsContainer>
              {valueForm.status == 500?
                //Button Status Reject
                <React.Fragment>
                  {valueForm.actions.map((actionKey) => 
                    <Button
                      type={actionKey=='Cancel'?'button':'submit'}
                      content={actionKey}
                      color={buttonColor[actionKey]}
                      onClick={()=>{
                        actionName.current = actionKey
                        if(actionKey=='Cancel') setShowConfirmComment(true)
                      }}
                    />)
                  }
                </React.Fragment>
                :
                //Button Status Draft or Other
                <React.Fragment>
                  {valueForm.status==0?//Status Draft Show button Delete
                  <Button 
                    type="button"
                    content='Delete' 
                    color='red' 
                    icon='trash alternate' 
                    labelPosition='right'
                    style={{ marginRight: '5px' }}
                    onClick={()=>{
                      actionName.current = 'Delete'
                      setShowConfirm(true)
                    }}
                  />:null}
                  <Button 
                    content='Save' 
                    icon='save' 
                    labelPosition='right'
                    style={{ marginRight: '5px' }}
                    onClick={()=>{
                      actionName.current = 'Save'
                    }}
                  />
                  <Button 
                    content='Save & Submit' 
                    color='blue' 
                    icon='save' 
                    labelPosition='right'
                    style={{ marginRight: '5px' }}
                    onClick={()=>{
                      actionName.current = 'Submit'
                    }}
                  />
                </React.Fragment>
              }
            </BottomActionsContainer>
          </form>
        </React.Fragment>:null
      }
      <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => confirmSubmit()}
      />
      <StdActionCommentModal
        open={showConfirmComment}
        onCancel={() => setShowConfirmComment(false)}
        onConfirm={props.handleSubmit(()=>onCancelForm())}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  const valueForm = getFormValues('formBGCompanyRequest')(state) || {}

  return ({
    valueForm,
    username,
    flowDetail:state.bgCompanyRequest.flowDetail.data,
    initialValues: {
      requesterUser: username,
      attachments: [],
      contacts: [],
      actions:[],
      isContactValid: true,
      ...state.bgCompanyRequest.detail.data
    },
    detailDocForExtend: state.bgCompany.detailDocForExtend.data
  })
}

const mapDispatchToProps = {
  getBGCompanyRequestDetail,
  getBGCRFlowDetail,
  updateBGCompanyRequest,
  deleteBGCompanyRequest,
  resubmitBGCompanyRequest,
  actionBGCompanyRequest,
  getVendors, 
  getCompanies,
  getListDocForExtend,
  getCustomers,
}

const validate = (values) => {
  let errors = validateField(values)
  return errors
}

const ContForm = reduxForm({
  form: 'formBGCompanyRequest',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(EditBankGuaranteeCompanyRequest)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
